import { render, staticRenderFns } from "./MemberChoose.vue?vue&type=template&id=4010b0b4&scoped=true&"
import script from "./MemberChoose.vue?vue&type=script&lang=js&"
export * from "./MemberChoose.vue?vue&type=script&lang=js&"
import style0 from "./MemberChoose.vue?vue&type=style&index=0&id=4010b0b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010b0b4",
  null
  
)

export default component.exports